<template>
  <div>
    <section class="plan-section pc-plan" id="plan-section">
      <div class="product-plan">
        <header class="plan-title section-title-wrapper">
          <div class="title-left">
            <h1 class="section-title" v-text="$t('home.plan_title')"></h1>
            <h2 class="section-sub-title" v-text="$t('home.plan_sub_title')"></h2>
          </div>
        </header>
        <div class="plan-imgs-wrapper">
          <div
            v-for="(item,index) in plans"
            :key="index"
            class="plan"
            :class="[{ 'active': activePlanIndex===index,'rotate': hoverPlanIndex===index,'plan-type1': item.type === 1,'plan-type2': item.type === 2,'plan-type3': item.type === 3,'bottom-year': item.position === 'bottom','top-year': item.position === 'top','inner-year': item.position === 'inner','shining':activePlanIndex===index||(activePlanIndex-1)===index}]"
            @mouseover="setPlanHover(index)"
            @mouseout="clearPlanHover"
            @click="activePlan(index)"
          >
            <div
              class="plan-date"
              :class="[{'bottom-date': item.position === 'bottom','top-date': item.position === 'top','inner-date': item.position === 'inner','hide-year':item.hideYear}]"
            >
              <div v-if="!item.hideYear" class="plan-year" v-text="item.year"></div>
              <div class="plan-month" v-text="item.fullYear||item.month"></div>
            </div>
            <div class="plan-img"></div>
          </div>
        </div>
        <div class="plan-des-container">
          <div class="plan-des-wrapper">
            <div
              class="plan-des-item"
              v-for="(item,index) in plans"
              :key="index"
              :class="{'active' : activePlanIndex===index}"
            >
              <div class="plan-content-title" v-text="item.title"></div>
              <div class="plan-content-des" v-html="item.des"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="wap-plan">
      <header class="wap-title-wrapper">
        <div class="wap-title-left">
          <div class="wap-section-title" v-text="$t('home.plan_title')"></div>
          <div class="wap-section-sub-title" v-text="$t('home.plan_sub_title')"></div>
        </div>
      </header>
      <div class="plan-content">
        <div class="swiper-container swiper-container-plan">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="item in plans" :key="item.id">
              <div class="plan-item-box">
                <div class="plan-item-title"><p v-text="item.fullYear?item.fullYear:item.year.replace('年','')+' '+item.month"></p></div>
                <div class="plan-item-content">
                  <div class="plan-item-date" v-text="item.title"></div>
                  <div class="plan-item-des" v-html="item.des"></div>
                  <div class="plan-item-des-fill"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="plan-bottom-wrapper">
          <div class="plan-pagination">
            <div
              class="plan-pagination-item"
              v-for="item in plans"
              :key="item.id"
              :class="{'active':current==item.id}"
              @click="slideTo(item.id)"
            >
              <div class="plan-pagination-date">
                <div class="plan-pagination-year" v-text="item.year.replace('年','')"></div>
                <div class="plan-pagination-month" v-text="item.fullYear?' ':item.month"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
import { animationScroll } from "@/assets/js/common";
export default {
  data() {
    return {
      activePlanIndex: 0,
      hoverPlanIndex: "",
      plans: [
        {
          id:1,
          type: 3,
          year: this.$i18n.t("plans.plan1.year"),
          fullYear: this.$i18n.t("plans.plan1.fullYear"),
          position: "bottom",
          title: this.$i18n.t("plans.plan1.title"),
          des: this.$i18n.t("plans.plan1.des")
        },
        {
          id:2,
          type: 3,
          year: this.$i18n.t("plans.plan2.year"),
          fullYear: this.$i18n.t("plans.plan2.fullYear"),
          position: "top",
          title: this.$i18n.t("plans.plan2.title"),
          des: this.$i18n.t("plans.plan2.des")
        },
        {
          id:3,
          type: 3,
          year: this.$i18n.t("plans.plan3.year"),
          fullYear: this.$i18n.t("plans.plan3.fullYear"),
          position: "bottom",
          title: this.$i18n.t("plans.plan3.title"),
          des: this.$i18n.t("plans.plan3.des")
        },
        {
          id:4,
          type: 3,
          year: this.$i18n.t("plans.plan4.year"),
          fullYear: this.$i18n.t("plans.plan4.fullYear"),
          position: "top",
          title: this.$i18n.t("plans.plan4.title"),
          des: this.$i18n.t("plans.plan4.des")
        },
        {
          id:5,
          type: 2,
          year: this.$i18n.t("plans.plan5.year"),
          fullYear: this.$i18n.t("plans.plan5.fullYear"),
          position: "inner",
          title: this.$i18n.t("plans.plan5.title"),
          des: this.$i18n.t("plans.plan5.des"),
          hideYear:true,
        },
        {
          id:6,
          type: 1,
          year: this.$i18n.t("plans.plan6.year"),
          fullYear: this.$i18n.t("plans.plan6.fullYear"),
          position: "top",
          title: this.$i18n.t("plans.plan6.title"),
          des: this.$i18n.t("plans.plan6.des"),
          hideYear:true,
        },
        {
          id:7,
          type: 2,
          year: this.$i18n.t("plans.plan7.year"),
          month: this.$i18n.t("plans.plan7.month"),
          position: "inner",
          title: this.$i18n.t("plans.plan7.title"),
          des: this.$i18n.t("plans.plan7.des")
        },
        {
          id:8,
          type: 1,
          year: this.$i18n.t("plans.plan8.year"),
          month: this.$i18n.t("plans.plan8.month"),
          position: "bottom",
          title: this.$i18n.t("plans.plan8.title"),
          des: this.$i18n.t("plans.plan8.des")
        },
        {
          id:9,
          type: 1,
          year: this.$i18n.t("plans.plan9.year"),
          month: this.$i18n.t("plans.plan9.month"),
          position: "top",
          title: this.$i18n.t("plans.plan9.title"),
          des: this.$i18n.t("plans.plan9.des")
        },
        {
          id:10,
          type: 2,
          year: this.$i18n.t("plans.plan10.year"),
          month: this.$i18n.t("plans.plan10.month"),
          position: "inner",
          title: this.$i18n.t("plans.plan10.title"),
          des: this.$i18n.t("plans.plan10.des")
        }
      ],
      planInterval: "",
      current: "2",
      swiperPlan: null
    };
  },
  methods: {
    setPlanHover(index) {
      this.hoverPlanIndex = index;
    },
    clearPlanHover() {
      this.hoverPlanIndex = "";
    },
    activePlan(index) {
      this.activePlanIndex = index;
      // 重启interval
      clearInterval(this.planInterval);
      this.setPlanInterval();
    },
    setPlanInterval() {
      var that = this;
      that.planInterval = setInterval(function() {
        that.activePlanIndex++;
        if (that.activePlanIndex >= that.plans.length) {
          that.activePlanIndex = 0;
        }
      }, 8000);
    },
    initSwiper() {
      var _this = this;
      _this.swiperPlan = new Swiper(".plan-content .swiper-container-plan", {
        autoplay: {
          delay: 8000
        },
        speed: 500,
        slidesPerView: 1, //重要 可以去swiper搜索
        centeredSlides: true, //重要
        initialSlide: 1,
        spaceBetween: 20,
        effect: "left",
        observer:true,
        observeParents:true,
        on: {
          slideChange: function() {
            _this.current = this.activeIndex + 1;
            var desDom = $('.swiper-container-plan').find('.swiper-slide').eq(this.activeIndex).find('.plan-item-des');
            var desScrollHeight = desDom.prop("scrollHeight");
            desDom.animate({ scrollTop: desScrollHeight }, 10000);
            desDom.scroll(function(){
                // scroll at bottom
                if (desDom.scrollTop()+desDom.height()>=desScrollHeight-2) {
                  desDom.stop();
                }
            });
          },
          slidePrevTransitionStart:function(){
            var desDom = $('.swiper-container-plan').find('.swiper-slide').eq(this.activeIndex+1).find('.plan-item-des');
            if (desDom) {
              desDom.stop();
              desDom.animate({ scrollTop: 0 }, 0);
            }
          },
          slideNextTransitionStart: function(){
             var desDom = $('.swiper-container-plan').find('.swiper-slide').eq(this.activeIndex-1).find('.plan-item-des');
            if (desDom) {
              desDom.stop();
              desDom.animate({ scrollTop: 0 }, 0);
            }
          },
        }
      });
    },
    slideTo(id) {
      this.swiperPlan.slideTo(id - 1);
    },
  },
  mounted() {
    let that = this;
    this.setPlanInterval();
    animationScroll($(".product-plan"));
    setTimeout(function() {
      that.initSwiper();
    }, 500);
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/pc/index/planSection.vue